import React from 'react'
import { IUser } from 'protos'

import T from 'components/FormattedMessage'
import FriendListItem from 'components/FriendListItem'
import withUserLayer, { UserLayerProps } from 'components/UserLayer/withUserLayer'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'

interface Props extends UserLayerProps {
  users: Array<IUser>
}

const UserSearchResult = withUserLayer<Props>(({ users, openUserLayer }) => (
  <List>
    <ListItem divider>
      <Typography variant="caption" color="textSecondary" style={{ flex: 1 }}>
        <T id="friends_section_searchresults" />
      </Typography>
    </ListItem>
    {users.map((user, i) => (
      <FriendListItem key={i} onClick={() => { openUserLayer(user.userId!) }} friend={user} />
    ))}
  </List>
))

export default UserSearchResult
